

































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, State, Action } from 'vuex-class';
import uuid from 'uuid/v4';

import Header from '@/components/Global/Header/Header.vue';
import Footer from '@/components/Global/Footer/Footer.vue';
import Loading from '@/components/Global/Loading.vue';
import NotificationBanner from '@/components/Global/Notification.vue';
// import ScreenSharingRequestModal from '@/components/Modal/ScreenSharingRequestModal.vue';
import LiveChatToggle from '@/components/LiveChat/LiveChatToggle.vue';
import ProxyBanner from '@/components/Global/ProxyBanner.vue';

// Services
import { Features } from '@/services/Features';
import User from '@/services/User';
import Brand from '@/services/Brand';
import Auth from '@/services/Auth';
// import {
// 	acceptScreenSharingRequest,
// 	addScreenSharingFeature,
// } from '@/services/ScreenSharing/ScreenSharingLogic';
import UnixDate from '@/utils/DateTime';
import axios from 'axios';
import {
	configureScope as sentryConfigureScope,
	captureException as sentryCaptureException,
} from '@sentry/browser';

import { addClass, removeClass } from '@/utils/jsHelpers';
const CACHED_TIMEOUT = 3600; // 5 Minutes

@Component({
	name: 'App',
	components: {
		Header,
		Footer,
		Loading,
		NotificationBanner,
		// ScreenSharingRequestModal,
		LiveChatToggle,
		ProxyBanner
	},
})
export default class App extends Vue {
	@Getter('loading', { namespace: 'Misc' }) private loading;
	@Getter('user', { namespace: 'Auth' }) private user;
	@Action('setCoreUser', { namespace: 'Auth' }) private setCoreUser: (payload) => void;

	// private readonly acceptScreenSharingRequest = acceptScreenSharingRequest;
	private readonly Features = Features;

	private key: string = '';
	private notificationBannerKey: string = uuid();
	private cleanWindow: boolean = true;
	private checkedLogin: boolean = false;
	private firstLoading: boolean = true;
	private insertBanner: boolean = false;
	private isLoggedIn: boolean = window.isLoggedIn;

	@Watch('$route', { deep: true })
	private watchRoute(newValue) {
		this.notificationBannerKey = uuid();
		if (
			newValue.name === 'stafforganizationtabbed' ||
			newValue.name === 'staffusermanagementsingle' ||
			newValue.name === 'staffpolicy' ||
			(newValue.name === 'RiskResourcesPages' &&
				newValue.params.pathMatch === 'news-and-events')
		) {
			this.key = newValue.name;
		} else {
			this.key = newValue.fullPath;
		}

		this.cleanWindow = newValue.meta.cleanWindow || false;
	}

	private async created() {
		// Detect brand
		this.$store.dispatch('Brand/setupBrand', {});
		Brand.setFavicon();
		if (this.$route.meta.cleanWindow) {
			this.cleanWindow = true;
		} else if (this.$route.name === null) {
			this.cleanWindow = true;
		} else {
			this.cleanWindow = false;
		}

		this.firstLoading = false;

		if (
			Brand.getBrand() === 'insurecareteams' &&
			window.localStorage.getItem('brokerageId') !== '' &&
			window.localStorage.getItem('brokerageId') !== null
		) {
			this.$store.dispatch('Auth/setBrokerageId', window.localStorage.getItem('brokerageId'));
		}

		// Check whether the latest deployed version is different than this version, except when
		// running locally.
		if (process.env.VUE_APP_ENV_TYPE !== 'local') {
			try {
				const thisVersionCommitId: string | undefined =
					process.env.VUE_APP_VERSION_COMMIT_ID;
				if (thisVersionCommitId) {
					const getVersionResponse = await axios.get(
						process.env.VUE_APP_API_URI2 + '/version',
					);
					const newestVersionCommitId: string = getVersionResponse.data.frontend.commitId;
					const currentTimestamp = UnixDate.now();
					if (
						newestVersionCommitId &&
						thisVersionCommitId !== newestVersionCommitId &&
						currentTimestamp - Number(window.localStorage.getItem('newVersionLoaded')) >
							CACHED_TIMEOUT
					) {
						const reload: boolean = confirm(
							`There is a newer version of the website available, Would you like to reload the page?`,
						);

						if (reload) {
							window.location.reload(true);
						}
						window.localStorage.setItem(
							'newVersionLoaded',
							currentTimestamp.toString(),
						);
					}
				}
			} catch (e) {
				sentryCaptureException(e);
			}
		}

		/**
		 * Track User Activity
		 */
		if (window.isLoggedIn) {
			removeClass(document.body, 'not-loggedin');
			// if (this.user?.email && this.user.email.indexOf('@constellationmutual.com') === -1) {
			User.trackUserInactivity();
			// }

			if (this.user !== null) {
				if (Auth.isAuthExpired()) {
					await this.$Amplify.Auth.signOut();
					this.$store.dispatch('Auth/signout');
				}
			}

			sentryConfigureScope(scope => {
				const id = 'sub' in this.user ? this.user.sub : null;
				const email = 'email' in this.user ? this.user.email : null;
				const username = 'username' in this.user ? this.user.username : null;

				scope.setUser({
					id,
					email,
					username,
				});
			});

			try {
				this.$gtag.set({
					user_id: this.user?.sub,
				});

				this.$gtag.config({
					user_id: this.user?.sub,
				});

				const getUser = await User.getUser();
				this.setCoreUser(getUser?.data);
			} catch {
				// Yo :D
			}
		} else {
			addClass(document.body, 'not-loggedin');
		}

		// if (this.Features.isScreenSharingWithUsersEnabled) {
		// 	addScreenSharingFeature();
		// }
	}
}
